import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";

export class FulfillmentMileDisplayListComponent implements IController {
  ids: any;
  isRow: any;
  onChange: Function;

  constructor() {
  }

  $onInit() {
  }

  $onChanges(changes) {
    if (changes.ids) {
      this.$onInit();
    }
  }

  onRemove(id) {
    this.onChange({ids: _.filter(this.ids, (i) => {return i !== id})});
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentMileDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      onChange: '&'
    },
    template: require('./fulfillment-mile-display-list.html').default,
    controller: FulfillmentMileDisplayListComponent
  });
